const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

// A row of A-Z buttons to quick-filter a list by first letter. Letters with
// no matching items are disabled (greyed out), not hidden — keeps the
// alphabet's shape stable regardless of what's currently in the list.
// nameKey defaults to 'name' (vendors/clients) but should be set to
// 'first_name' for contractors/people, since V10 splits those names.
export default function AlphaFilter({ items, nameKey = 'name', value, onChange }) {
  const available = new Set((items || []).map(i => (i[nameKey] || '').charAt(0).toUpperCase()));

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2, margin: '8px 0' }}>
      {LETTERS.map(l => {
        const has = available.has(l);
        const active = value === l;
        return (
          <button key={l} onClick={() => onChange(active ? '' : l)} disabled={!has}
            style={{
              width: 22, height: 22, border: '1px solid',
              borderColor: active ? 'var(--navy)' : 'var(--border)',
              borderRadius: 3, fontSize: 9, fontWeight: active ? 700 : 500, cursor: has ? 'pointer' : 'default',
              background: active ? 'var(--navy)' : 'var(--surface)',
              color: active ? '#fff' : has ? 'var(--text)' : 'var(--text-muted)',
              opacity: has ? 1 : 0.35, transition: 'all .12s',
            }}>
            {l}
          </button>
        );
      })}
      {value && (
        <button onClick={() => onChange('')}
          style={{ padding: '0 8px', height: 22, border: '1px solid var(--border)', borderRadius: 3, fontSize: 9, cursor: 'pointer', background: 'var(--surface)', color: 'var(--text-muted)' }}>
          All
        </button>
      )}
    </div>
  );
}
